import { all, takeEvery, put, call } from "redux-saga/effects";
import axiosMain from "../../../http/axios/axios_main";
import * as actionTypes from "../../actionLabels";
import * as englishActions from "../../actions";
import CustomToast from "../../../components/Toast";
import axios from "axios";

function* getEnglishAuctionHeaderData(action) {
  try {
    let auctionDetailId = Number(action.payload);
    if (isNaN(auctionDetailId) || auctionDetailId <= 0) {
      auctionDetailId = 0;
    }

    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer your_access_token",
      userLoginId: 10929,
    };
    //const response = yield call(axios.get, 'http://localhost:9199/englishauction/getauctionheaderdata/'+auctionDetailId, { headers: headers });
    const response = yield call(
      axiosMain.get,
      "/englishauction/getauctionheaderdata/" + auctionDetailId
    );

    if (response.status === 200) {
      if (response.data.statusCode === 200) {
        yield put(
          englishActions.fetchEnglishAuctionHeaderDataSuccess(response.data)
        );
      } else {
        CustomToast.error(response.data.message);
        yield put(
          englishActions.fetchEnglishAuctionHeaderDataFailure(
            response.data.message
          )
        );
      }
    } else {
      CustomToast.error(
        "Failed to fetch data. Status code: " + response.status
      );
      yield put(
        englishActions.fetchEnglishAuctionHeaderDataFailure(
          "Failed to fetch data. Status code: " + response.status
        )
      );
    }
  } catch (error) {
    console.error("Error occurred during API call:", error);
    CustomToast.error("Error occurred during API call: " + error.message);
    yield put(
      englishActions.fetchEnglishAuctionHeaderDataFailure(
        "Error occurred during API call: " + error.message
      )
    );
  }
}

function* viewUserWiseEnglishAuctionData(action) {
  try {
    let auctionDetailId = Number(action.payload.auctionDetailId);
    if (isNaN(auctionDetailId) || auctionDetailId <= 0) {
      auctionDetailId = 0;
    }
    let userLoginId = action.payload.userLoginId;
    //const response = yield call(axios.get, `http://localhost:9199/englishauction/viewuserwiseliveauction/${auctionDetailId}/${userLoginId}`);
    const response = yield call(
      axiosMain.get,
      `/englishauction/viewuserwiseliveauction/${auctionDetailId}/${userLoginId}`
    );

    if (response.status === 200) {
      if (response.data.statusCode === 200) {
        let checkResume = response.data.responseData.isResume;

        if(checkResume == 1){
          response.data.responseData.cstatus = 1;
        }
        yield put(
          englishActions.viewUserWiseLiveEnglishAuctionSuccess(response.data)
        );
        yield put(englishActions.fetchEnglishAuctionCenterDataApiCall(true));
        if (
          action.payload.sahilset != undefined &&
          action.payload.sahilset == 1
        ) {
          yield put(englishActions.viewBidSuccess(response.data));
        }
      } else {
        CustomToast.error(response.data.message);
        yield put(
          englishActions.viewUserWiseLiveEnglishAuctionFailure(
            response.data.message
          )
        );
      }
    } else {
      CustomToast.error(
        "Failed to fetch data. Status code: " + response.status
      );
      yield put(
        englishActions.viewUserWiseLiveEnglishAuctionFailure(
          "Failed to fetch data. Status code: " + response.status
        )
      );
    }
  } catch (error) {
    console.error("Error occurred during API call:", error);
    CustomToast.error("Error occurred during API call: " + error.message);
    yield put(
      englishActions.viewUserWiseLiveEnglishAuctionFailure(
        "Error occurred during API call: " + error.message
      )
    );
  }
}
function* fetchDefaultColumnConfigSaga(action) {
  try {
    let userId = action.payload.userId;
    let auctionDetailId = action.payload.auctionDetailId;
    const formData = new FormData();
    formData.append("auctionDetailId", "179");
    formData.append("userLoginId", "182");
    //const response = yield call(axios.get, 'http://localhost:9199/englishauction/getuserwisecolumnconfig/'+userId+'/'+auctionDetailId);
    const response = yield call(
      axiosMain.get,
      "/englishauction/getuserwisecolumnconfig/" +
        userId +
        "/" +
        auctionDetailId
    );

    if (response.status === 200) {
      // if (response.data.statusCode === 200) {
      yield put(englishActions.fetchDefaultColumnConfigSuccess(response.data));
      // } else {
      //   CustomToast.error(response.data.message);
      //   yield put(englishActions.fetchDefaultColumnConfigSuccess(response.data.message));
      // }
    } else {
      CustomToast.error(
        "Failed to fetch data. Status code: " + response.status
      );
      yield put(
        englishActions.fetchDefaultColumnConfigSuccess(
          "Failed to fetch data. Status code: " + response.status
        )
      );
    }
  } catch (error) {
    console.error("Error occurred during API call:", error);
    CustomToast.error("Error occurred during API call: " + error.message);
    yield put(
      englishActions.fetchDefaultColumnConfigSuccess(
        "Error occurred during API call: " + error.message
      )
    );
  }
}
function* catelogFetchAllData(action) {
  try {
    let userLoginId = action.payload.userLoginId;
    let auctionDetailId = action.payload.auctionDetailId;

    // const response = yield call(
    //   axiosMain.post,
    //   `/auctionbid/getuserwisecolumnconfig?userLoginId=${userLoginId}&auctionDetailId=${auctionDetailId}`
    // );
    //const response = yield call(axios.post, 'http://localhost:9199/englishauction/getuserwisecolumnconfig?userLoginId=${userLoginId}&auctionDetailId=${auctionDetailId}');
    const response = yield call(
      axiosMain.post,
      `/englishauction/getuserwisecolumnconfig?userLoginId=${userLoginId}&auctionDetailId=${auctionDetailId}`
    );
    if (response.status == 200) {
      if (response.data.statusCode == 1) {
        // CustomToast.success(response.data.message);
        yield put(
          englishActions.englishcatelogFetchAllDataSuccess(response.data)
        );
      } else {
        CustomToast.error(response.data.message);
        yield put(
          englishActions.englishcatelogFetchAllDataFailure(
            response.data.message
          )
        );
      }
    } else {
      CustomToast.error(response.data.message);
      yield put(
        englishActions.englishcatelogFetchAllDataFailure(response.data.message)
      );
    }
  } catch (error) {
    // CustomToast.error("");
    yield put(englishActions.englishcatelogFetchAllDataFailure(error));
  }
}
function* addcatalogcolumnconfig(action) {
  try {
    const response = yield call(
      axiosMain.post,
      "/englishauction/addcatalogcolumnconfig",
      action.payload
    );
    if (response.status == 200) {
      if (response.data.statusCode == 200) {
        yield put(englishActions.addCatalogColumnConfigSuccess(response.data));
      } else {
        CustomToast.error(response.data.message);
        yield put(
          englishActions.addCatalogColumnConfigFailure(response.data.message)
        );
      }
    } else {
      CustomToast.error(response.data.message);
      yield put(
        englishActions.addCatalogColumnConfigFailure(response.data.message)
      );
    }
  } catch (error) {
    yield put(englishActions.addCatalogColumnConfigFailure(error));
  }
}
function* lotWiseBidAcceptSaga(action) {
  try {
    const response = yield call(
      axiosMain.post,
      "/englishauction/lotWiseBidAccept",
      action.payload
    );
    if (response.status == 200) {
      if (response.data.statusCode == 200) {
        const responseData = {
          ...response.data, 
          auctionItemDetailId: action.payload.auctionItemDetailId,
          buyingQuantity: action.payload.buyingQuantity,
        };
        yield put(englishActions.lotWiseBidAcceptSuccess(responseData));
      } else {
        CustomToast.error(response.data.message);
        yield put(
          englishActions.lotWiseBidAcceptFailure(response.data.message)
        );
      }
    } else {
      CustomToast.error(response.data.message);
      yield put(englishActions.lotWiseBidAcceptFailure(response.data.message));
    }
  } catch (error) {
    yield put(englishActions.lotWiseBidAcceptFailure(error));
  }
}

function* fetchBidBookSaga(action) {
  try {
    const response = yield call(
      axiosMain.post,
      "/englishauction/searchviewBidBook",
      action.payload
    );
    if (response.status == 200) {
      if (response.data.statusCode == 200) {
        if (action.payload.isExport == 1) {
          yield put(englishActions.fetchBidBookExportSuccess(response.data));
        } else {
          yield put(englishActions.fetchBidBookSuccess(response.data));
          if (action.payload.isfirstcall == true) {
            yield put(
              englishActions.fetchBidBookSearchDropdownDataSuccess(
                response.data
              )
            );
          }
        }
      } else {
        CustomToast.error(response.data.message);
        yield put(englishActions.fetchBidBookSuccess(response.data));
      }
    } else {
      CustomToast.error(response.data.message);
      yield put(englishActions.fetchBidBookFailure(response.data.message));
    }
  } catch (error) {
    yield put(englishActions.fetchBidBookFailure(error));
  }
}

function* fetchSessionTimeSaga(action) {
  try {
    const response = yield call(
      axiosMain.post,
      "/preauction/Common/BindBidBookSessionTime",
      action.payload
    );
    if (response.status == 200) {
      if (response.data.statusCode == 200) {
        yield put(englishActions.fetchSessionTimeSuccess(response.data));
      } else {
        CustomToast.error(response.data.message);
        yield put(englishActions.fetchSessionTimeSuccess(response.data));
      }
    } else {
      CustomToast.error(response.data.message);
      yield put(englishActions.fetchSessionTimeFailure(response.data.message));
    }
  } catch (error) {
    yield put(englishActions.fetchSessionTimeFailure(error));
  }
}
function* fetchLotSaga(action) {
  try {
    const response = yield call(
      axiosMain.get,
      `/englishauction/getLotNo/${action.payload}`
    );
    if (response.status == 200) {
      if (response.data.statusCode == 200) {
        yield put(englishActions.fetchLotSuccess(response.data));
      } else {
        CustomToast.error(response.data.message);
        yield put(englishActions.fetchLotFailure(response.data));
      }
    } else {
      CustomToast.error(response.data.message);
      yield put(englishActions.fetchLotFailure(response.data));
    }
  } catch (error) {
    yield put(englishActions.fetchLotFailure(error));
  }
}
function* viewUserBidData(action) {
  try {
    let auctionDetailId = action.payload.auctionDetailId;
    let userLoginId = action.payload.userLoginId;
    //const response = yield call(axios.get, `http://localhost:9199/englishauction/viewuserwiseliveauction/${auctionDetailId}/${userLoginId}`);
    const response = yield call(
      axiosMain.get,
      `/englishauction/viewuserwiseliveauction/${auctionDetailId}/${userLoginId}`
    );

    if (response.status === 200) {
      if (response.data.statusCode === 200) {
        let checkResume = response.data.responseData.isResume;

        if(checkResume == 1){
          response.data.responseData.cstatus = 1;
        }
        yield put(englishActions.viewBidSuccess(response.data));
        yield put(englishActions.fetchEnglishAuctionCenterDataApiCall(true));
      } else {
        CustomToast.error(response.data.message);
        yield put(englishActions.viewBidFailure(response.data.message));
      }
    } else {
      CustomToast.error(
        "Failed to fetch data. Status code: " + response.status
      );
      yield put(
        englishActions.viewBidFailure(
          "Failed to fetch data. Status code: " + response.status
        )
      );
    }
  } catch (error) {
    console.error("Error occurred during API call:", error);
    CustomToast.error("Error occurred during API call: " + error.message);
    yield put(
      englishActions.viewBidFailure(
        "Error occurred during API call: " + error.message
      )
    );
  }
}
function* DefaultCloumnConfigLiveAuction(action) {
  try {
    const auctionDetailId = action.payload.auctionDetailId;
    const userLoginId = action.payload.userLoginId;
    const UserData = yield call(
      axiosMain.get,
      `/englishauction/getuserwisedefaultcolumnconfig/${userLoginId}/${auctionDetailId}`
    );
    if (UserData.status == 200) {
      let catalogColumnConfigurationDetails = UserData?.data?.responseData;
      let payloadData = {
        auctionDetailId: auctionDetailId,
        userLoginId: userLoginId,
        catalogColumnConfigurationDetails: catalogColumnConfigurationDetails,
      };
      const UserData1 = yield call(
        axiosMain.post,
        `/englishauction/addcatalogcolumnconfig`,
        payloadData
      );
      if (UserData1.status == 200) {
        yield put(
          englishActions.completeAddCatalogColumnConfig(UserData1.data)
        );
        yield put(
          englishActions.viewUserWiseLiveEnglishAuctionRequest({
            auctionDetailId: auctionDetailId,
            userLoginId: userLoginId,
            sahilset: 1,
          })
        );
        CustomToast.success("Restore Defaults Catalog Configured successfully");
      }
    } else {
      yield put(
        englishActions.errorAddCatalogColumnConfig(UserData.data.message)
      );
    }
  } catch (error) {
    yield put(englishActions.errorAddCatalogColumnConfig(error));
  }
}

export default function* englishAuctionSagas() {
  yield takeEvery(
    actionTypes.FETCH_ENGLISH_AUCTION_HEADER_DATA_REQUEST,
    getEnglishAuctionHeaderData
  );
  yield takeEvery(
    actionTypes.VIEW_USER_WISE_LIVE_ENGLISH_AUCTION_REQUEST,
    viewUserWiseEnglishAuctionData
  );
  yield takeEvery(
    actionTypes.FETCH_DEFAULT_COLUMN_CONFIG_REQUEST,
    fetchDefaultColumnConfigSaga
  );
  yield takeEvery(
    actionTypes.ENGLISH_CATELOG_FETCH_ALL_DATA,
    catelogFetchAllData
  );
  yield takeEvery(
    actionTypes.ADD_CATALOG_COLUMN_CONFIG_REQUEST,
    addcatalogcolumnconfig
  );
  yield takeEvery(
    actionTypes.LOT_WISE_BID_ACCEPT_REQUEST,
    lotWiseBidAcceptSaga
  );
  yield takeEvery(actionTypes.FETCH_BID_BOOK_REQUEST, fetchBidBookSaga);
  yield takeEvery(actionTypes.FETCH_SESSION_TIME_REQUEST, fetchSessionTimeSaga);
  yield takeEvery(actionTypes.FETCH_LOT_REQUEST, fetchLotSaga);
  yield takeEvery(actionTypes.VIEW_BID_REQUEST, viewUserBidData);
  yield takeEvery(
    actionTypes.ADD_CATALOG_COLUMN_CONFIG_INITIATE,
    DefaultCloumnConfigLiveAuction
  );
}
